
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BasicSetupScreen from '@components/vehicle-setup/BasicSetupScreen.vue';

@Component({
  name: 'SetupStep2',
  components: {
    BasicSetupScreen,
  }
})
export default class SetupStep2 extends Vue {
  get publicFolder() {
    return process.env.BASE_URL;
  }
}
